export default __webpack_public_path__ + "static/media/popular.7e1d4158.png";